import type { ReferralListDirection } from '../../../types/engagement-metrics.types';

// Feature 117: copy accepted in tickets 04 / 07 / 10.

export const REFERRALS_TAB_SUBTITLE =
  'Every referral recorded in bQuest, from the platform and from admins, plus call requests. Manual referrals can be added, edited, and deleted here. Deleted referrals are hidden.';

export const DIRECTION_LABELS: Record<ReferralListDirection, string> = {
  FA_TO_SP: 'FA → SP',
  SP_TO_SP: 'SP → SP',
  CONCIERGE_TO_SP: 'Concierge → SP',
  SP_TO_FA: 'SP → FA',
  FA_TO_FA: 'FA → FA',
  CONCIERGE_TO_FA: 'Concierge → FA',
  CALL_REQUEST: 'Call request',
};

export const REFERRAL_COLUMNS = {
  type: {
    label: 'Type',
    tip: 'Who referred whom, by role. Call request = a care seeker asked a provider to call them; billed like a referral but not one.',
  },
  referred: { label: 'Referred', tip: 'The professional who received the referral.' },
  referralDate: {
    label: 'Referral date',
    tip: 'When the referral happened. For manual referrals, the date the admin entered; for platform referrals, when it was sent.',
  },
  referrer: {
    label: 'Referrer',
    tip: 'The professional (or bQuest Concierge) who made the referral. Empty on call requests.',
  },
  careSeeker: {
    label: 'Care seeker',
    tip: 'The client the referral is about, if any. A platform referral with several clients shows one row per client.',
  },
  onBehalfOf: {
    label: 'On behalf of',
    tip: 'The professional the referral was made for, when someone referred on their behalf.',
  },
  origin: {
    label: 'Origin',
    tip: 'Platform = created in-app by the user. Manual = recorded by an admin (modal or bulk import); only these can be edited or deleted.',
  },
  billable: {
    label: 'Billable',
    tip: 'Whether this referral counts toward provider billing. Referrals to financial advisors and to contacts without an account are not billable.',
  },
  createdDate: {
    label: 'Created date',
    tip: 'When the record was saved in bQuest. Can differ from the referral date for manual referrals entered later.',
  },
  actions: { label: 'Actions', tip: 'Edit or delete a manual referral. Platform referrals are read-only.' },
} as const;

export const formatReferralDate = (iso: string) =>
  new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });

export const importBatchTip = (batch: { filename: string; createdAt: string; adminName: string | null }) =>
  `Imported from ${batch.filename} on ${formatReferralDate(batch.createdAt)} by ${batch.adminName ?? 'an admin'}`;
